<template>
  <v-select label="Número de Parte de Proceso" class="pl-3"
    v-model="selected"
    item-title="processNo"
    item-value="id"
    :items="getProcessNumberList"
    multiple
    chips
    hint="Seleccione uno o mas partes de procesos"
    persistent-hint
    >
  </v-select>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ProcessSelector',

  props: {
    modelValue: Array
  },

  data: () => ({
  }),

  computed: {
    ...mapGetters('processModule', ['getProcessNumberList']),
    selected: {
      get () { return this.modelValue },
      set (v) {
        this.$emit('update:modelValue', v)
      }
    }
  },

  created () {
    this.proceses = this.initialValue
  }
}
</script>
